export default class Coordinate {
  static fromJSON (json) {
    return new Coordinate({
      latitude: json.latitude,
      longitude: json.longitude
    })
  }

  constructor ({ latitude, longitude }) {
    this.latitude = latitude
    this.longitude = longitude
  }
}
